'use client';
import { useSession } from '../../lib/session';
import { Banner, Desk, PageHeader } from '../../components/desk';
import { IndicatorWorkspace } from '../../components/desk/indicator-workspace';
const readers = ['PROFILE_CASE_HANDLER', 'PROFILE_CASE_REVIEWER', 'ORGANIZATION_ADMIN', 'ACTIVITY_COORDINATOR', 'PARTICIPATION_REVIEWER', 'CONTENT_EDITOR', 'CHANNEL_PUBLISHER'];
export default function IndicatorsPage() {
  const session = useSession();
  if (!readers.some(r => session.hasRole(r))) return <Desk><PageHeader eyebrow="治理与核对" title="基础指标与来源" /><Banner tone="warning">当前职责不包含这一台，请核对我的授权。</Banner></Desk>;
  return <IndicatorWorkspace />;
}
